import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import BoardPage from "./pages/BoardPage";
import ProfilePage from "./pages/ProfilePage";
import MembersPage from "./pages/MembersPage";
import LegalPage from "./pages/LegalPage";
import PendingPage from "./pages/PendingPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import NewsPage from "./pages/NewsPage";
import EventsPage from "./pages/EventsPage";
import FestivalPage from "./pages/FestivalPage";
import FestivalPublicPage from "./pages/FestivalPublicPage";
import ForumPage from "./pages/ForumPage";
import LernenPage from "./pages/LernenPage";
import ToolsPage from "./pages/ToolsPage";
import ChatPage from "./pages/ChatPage";
import AdminPage from "./pages/AdminPage";
import VideosPage from "./pages/VideosPage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/festival/:id" element={<FestivalPublicPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/pending" element={<ProtectedRoute requireApproved={false}><PendingPage /></ProtectedRoute>} />
            <Route path="/board" element={<ProtectedRoute><BoardPage /></ProtectedRoute>} />
            <Route path="/events" element={<ProtectedRoute><EventsPage /></ProtectedRoute>} />
            <Route path="/events/festival/:id" element={<ProtectedRoute><FestivalPage /></ProtectedRoute>} />
            <Route path="/news" element={<ProtectedRoute><NewsPage /></ProtectedRoute>} />
            <Route path="/news/videos" element={<ProtectedRoute><VideosPage /></ProtectedRoute>} />
            <Route path="/forum" element={<ProtectedRoute><ForumPage /></ProtectedRoute>} />
            <Route path="/lernen" element={<ProtectedRoute><LernenPage /></ProtectedRoute>} />
            <Route path="/lernen/:trackId" element={<ProtectedRoute><LernenPage /></ProtectedRoute>} />
            <Route path="/lernen/:trackId/:lessonId" element={<ProtectedRoute><LernenPage /></ProtectedRoute>} />
            <Route path="/tools" element={<ProtectedRoute><ToolsPage /></ProtectedRoute>} />
            <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute requireApproved={false} requireCompleteProfile={false}><ProfilePage /></ProtectedRoute>} />
            <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminPage /></ProtectedRoute>} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/impressum" element={<LegalPage initialTab="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage initialTab="datenschutz" />} />
            <Route path="/nutzungsbedingungen" element={<LegalPage initialTab="nutzungsbedingungen" />} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
